import { createSlice } from "@reduxjs/toolkit";
import { InitialState, } from "./types";
import { fetchAllUsers, sendInvite } from "./action"

const initialState: InitialState = {
    loading: false,
    usersData: {
        data: [],
        total: 0
    },
};

const userSlices = createSlice({
    name: "users",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllUsers.pending, (state) => {
            return {
                ...state,
                loading: false
            };
        });
        builder.addCase(fetchAllUsers.fulfilled, (state, action) => {
            const { payload } = action.payload;
            return {
                ...state,
                loading: false,
                usersData: {
                    data: payload.accounts,
                    total: payload.total
                },
            };
        });

        builder.addCase(fetchAllUsers.rejected, (state, action) => {
            return {
                ...state,
                loading: false,
                usersData:{
                    data:[],
                    total:0
                }
            };
        });

        builder.addCase(sendInvite.pending, (state) => {
            return {
                ...state,
                loading: true
            };
        });
        builder.addCase(sendInvite.fulfilled, (state, action) => {
            const { payload, pageData } = action.payload;
            return {
                ...state,
                loading: false,
                message: payload.message,

                error: false
            };
        });

        builder.addCase(sendInvite.rejected, (state, action) => {
            return {
                ...state,
                loading: false,
                // message: action.payload,
                error: true
            };
        });


    }
});
export default userSlices.reducer;